// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3bit9","productName":"Table_productName__3I3Kk"};